/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import SEO from "../components/seo/seo.component"
import Header from "../components/header/header.component"
import { AppContainer } from "../styles/app.styles"
import Footer from "./footer/footer.component"
import { ParallaxProvider } from "react-scroll-parallax"
import DemoDrawer from "./demo-drawer/demo-drawer.component"
import { isBrowser } from "../utils/utils"

const Layout = ({ seo, children, istreezpage, isLightHeader }) => {
  const [pathName, setPathName] = useState("")

  useEffect(() => {
    if (isBrowser()) {
      const url = window.location
      setPathName(url.pathname)
    }
  }, [])
  return (
    <>
      <ParallaxProvider>
        {seo && <SEO data={seo} />}
        <DemoDrawer />
        <Header isTreezPage={istreezpage} isLightHeader={isLightHeader} />
        <AppContainer className={pathName === "/" && "overflowHidden"}>
          {children}
        </AppContainer>
        <Footer isTreezPage={istreezpage} />
      </ParallaxProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
